import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { AssetManager } from '../../../../sharpr/assetManager/AssetManager.js';

export function EmailContactsEditRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailContactsEdit', {
		url: '/admin/contacts/:id/edit',
		controllerAs: 'vm',
		controller: EmailContactsEditCtrl,
		templateUrl: '/ng/hub/Email/Contacts/Edit/EmailContactsEditCtrl.html?' + window.BUILD,
		permission: ['manage_users'],
		resolve: {
			$title: () => 'Edit Email Contact',
			style: () => AssetManager.css('/ng/hub/Email/Contacts/Edit/EmailContactsEditCtrl.css'),
			user: ApiResourcify.endpoint('/users/:id'),
		},
	});
}

export class EmailContactsEditCtrl {
	constructor(Api, user) {
		'ngInject';
		this.Api = Api;
		this.user = user;
	}

	isUserValid() {
		return this.user && this.user.fname && this.user.lname && /^[^@]+@[^@]+\.[^@]{2,}$/.test(this.user.email);
	}

	update() {
		this.submitting = true;
		this.Api.patch(`/contacts/${this.user.id}`, {
			email: this.user.email,
			fname: this.user.fname,
			lname: this.user.lname,
			fname_preferred: this.user.fname_preferred,
			lname_preferred: this.user.lname_preferred,
		}).then(() => {
			// close the modal if we are in one
			this.$resolve && this.$resolve();
		});
	}
}
